import React from "react";
import { RigidBody, CuboidCollider } from "@react-three/rapier";
import type { MapData } from "../../types/MapData.types";

interface MapBoundariesProps {
  ground: MapData["terrain"]["ground"];
}

export default function MapBoundaries({ ground }: MapBoundariesProps) {
  if (!ground || ground.type !== "plane") return null;

  const [width, , depth] = ground.size;
  const [x, y, z] = ground.position;
  const wallHeight = 20;
  const wallThickness = 1;

  return (
    <RigidBody type="fixed" sensor={false}>
      <CuboidCollider position={[x, y + wallHeight / 2, z - depth / 2 - wallThickness / 2]} args={[width / 2 + wallThickness, wallHeight / 2, wallThickness / 2]} />
      <CuboidCollider position={[x, y + wallHeight / 2, z + depth / 2 + wallThickness / 2]} args={[width / 2 + wallThickness, wallHeight / 2, wallThickness / 2]} />
      <CuboidCollider position={[x - width / 2 - wallThickness / 2, y + wallHeight / 2, z]} args={[wallThickness / 2, wallHeight / 2, depth / 2]} />
      <CuboidCollider position={[x + width / 2 + wallThickness / 2, y + wallHeight / 2, z]} args={[wallThickness / 2, wallHeight / 2, depth / 2]} />
    </RigidBody>
  );
}
